import React from 'react'

import Base from '../_Base'

const PerkManga = (props) => (
  <Base width="40" height="40" viewBox="0 0 40 40" {...props}>
    <path
      d="M36 0v40H4V0h32zm-2 2H17v11H6v25h28V2zM20 15l3 5 6-2-3 10H14l-3-10 6 2 3-5zm0 3.886-2.11 3.519-3.868-1.29 1.465 4.884h9.025l1.465-4.884-3.867 1.29L20 18.886zM15 3.414 7.414 11H15V3.414zM13.584 2H6v7.584L13.584 2z"
      fillRule="evenodd"
    />
  </Base>
)

export default PerkManga
